export default __webpack_public_path__ + "static/media/calculator-logo2.3e544615.png";